export default {
  "AgreementSelectionContents.Text2":
    "すでに{linebreak}「個人関連情報の個人データとしての取得・利用」{linebreak}「広告目的でのIPアドレス利用」{linebreak}「ドコモのパートナーへの第三者提供」{linebreak}の同意事項にご登録いただいております{linebreak}ご協力ありがとうございました",
  "AgreementSelectionContents.Text3": "ページ処理中に問題が発生しました",
  "AgreementSelectionContents.AnnounceText1":
    "ご登録内容は、いつでも{linebreak}",
  "AgreementSelectionContents.AnnounceText2": "で{linebreak}",
  "AgreementSelectionContents.AnnounceText3": "ご変更いただけます",
  "AgreementSelectionContents.LinkText1": "パーソナルデータダッシュボード",
}
